import { render } from "./WpiszKod.vue?vue&type=template&id=5c58cff4&scoped=true"
import script from "./WpiszKod.vue?vue&type=script&lang=js"
export * from "./WpiszKod.vue?vue&type=script&lang=js"

import "./WpiszKod.vue?vue&type=style&index=0&id=5c58cff4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c58cff4"]])

export default __exports__